import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { routes } from '../lib/routes';
import { useAuth } from '../contexts/AuthContext';
import { Spinner } from '../components/common';

interface PrivateLayoutProps {
  children?: React.ReactNode;
}

const PublicLayout = ({ children }: PrivateLayoutProps) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className='min-h-screen bg-white flex items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={routes.home} replace />;
  }

  return <>{children || <Outlet />}</>;
};

export default PublicLayout;
